// Import Routes
import * as ROUTES from "../routes";

import TRANSACTIONS from '@/modules/transactions/views'
import WITHDRAWALS from '@/modules/transactions/views/withdrawals';

const routes = [
    {
        path: ROUTES.TRANSACTIONS,
        name: "Transactions",
        component: TRANSACTIONS,
        meta: {
            title: "Wallet Transactions",
            layout: "private",
            requiresAuth: true,
            nav: 'Transactions',
            permissions: ['can_view_transactions']
        }
    },
    {
        path: ROUTES.WITHDRAWALS,
        name: "Transactions",
        component: WITHDRAWALS,
        meta: {
            title: "Wallet Withdrawals",
            layout: "private",
            requiresAuth: true,
            nav: 'Transactions',
            permissions: ['can_view_transactions']
        }
    },
]

export default routes;